<div class="modal-header">
	<button class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Werte auswählen"}}</h4>
</div>
<div class="modal-body">
	<div id="selectValuesInput"></div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	{{#unless noValueSpecsAvailable}}
	<button class="btn btn-primary" id="js-save">{{TR "Speichern"}}</button>
	{{/unless}}
</div>
